import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { CourseShowPageState } from '../../../containers/courses/states/CourseShowPageState';
import { GlobalLoader } from '../../../../mainv2/components/GlobalLoader';

type Props = {
    courseState: CourseShowPageState;
    match: {
        params: {
            lessonId: string;
        };
    };
};

@inject('courseState')
@observer
export class LessonDetailsPage extends React.Component<Props> {
    render() {
        const { courseState } = this.props;
        const params = this.props.match.params;
        const lessonId = Number(params.lessonId);
        if (courseState.loading) {
            return <GlobalLoader />;
        }
        this.props.courseState.startOrResume(lessonId);
        return null;
    }
}
